import { localStorage } from '../../../kodyl/web-storage';

const CHANGE_LANGUAGE = 'l10n/CHANGE_LANGUAGE';

const LOCALES = {
  da: require('../../../locales/da/translation.json'),
  en: require('../../../locales/en/translation.json')
};

const DEFAULT_LANGUAGE = localStorage.getItem('language') || 'da';

const initialState = setLocale(DEFAULT_LANGUAGE);

function setLocale(lang) {
  if (__CLIENT__) {
    localStorage.setItem('language', lang);
  }
  return {
    lang,
    locale: LOCALES[lang] || {}
  };
}

export default function l10n(state = initialState, action) {
  if (action.type === CHANGE_LANGUAGE) {
    const lang = action.payload;
    return {
      ...state,
      ...setLocale(lang)
    };
  }

  return state;
}

export function changeLanguage(lang) {
  return {
    type: CHANGE_LANGUAGE,
    payload: lang
  };
}

export function serialize(state) {
  return state.lang;
}

export function deserialize(state) {
  return setLocale(state);
}
